// Mock data for teen party website
export const partyData = {
  ticketsSold: 23,
  ticketsRequired: 35,
  ticketsTotal: 80,
  ticketPrice: 26,
  partyDate: '2024-11-29',
  contactEmail: 'party@rigateens.lv',
  venue: 'Private Venue, Riga City Center'
};

export const features = [
  {
    icon: 'music',
    title: 'Professional DJ + Sound System',
    description: 'Top-tier audio setup for the best vibes'
  },
  {
    icon: 'tent',
    title: 'Private Venue',
    description: '80 capacity max - intimate and exclusive'
  },
  {
    icon: 'cup-soda',
    title: 'Drinks Included',
    description: 'Non-alcoholic drinks on the house'
  },
  {
    icon: 'camera',
    title: 'Photo Booth + Pro Photos',
    description: 'Capture the memories professionally'
  },
  {
    icon: 'party-popper',
    title: '4 Hours of Pure Chaos',
    description: 'Non-stop energy from start to finish'
  },
  {
    icon: 'shield-check',
    title: 'Safe & Organized',
    description: 'Age-appropriate, secure environment'
  }
];

export const timeline = [
  {
    step: '1',
    title: 'Buy Ticket',
    description: 'Secure your spot with Stripe payment. Your money is held safely.'
  },
  {
    step: '2',
    title: 'We Hit 35 Tickets',
    description: 'Party is confirmed and venue gets booked. No going back now!'
  },
  {
    step: '3',
    title: 'If We Don\'t Hit 35',
    description: 'Full automatic refund, no questions asked. Zero risk for you.'
  },
  {
    step: '4',
    title: 'Party Day',
    description: 'Get entry details via email. Show up and have the time of your life.'
  }
];

export const faqs = [
  {
    question: 'Is this legal?',
    answer: 'Yes! 15+ events are completely legal in Latvia with proper venue licensing. We have all permits and adult supervision.'
  },
  {
    question: 'What if the party doesn\'t happen?',
    answer: 'Automatic full refund through Stripe. If we don\'t hit 35 tickets, everyone gets their money back within 5-7 business days.'
  },
  {
    question: 'Is it safe?',
    answer: 'Absolutely. Professional venue with security, adult supervision, emergency protocols, and strictly age-appropriate environment.'
  },
  {
    question: 'Can I bring friends?',
    answer: 'Yes! Share the link with your friends. The more, the merrier (up to 80 people max).'
  },
  {
    question: 'What should I wear?',
    answer: 'Casual and comfortable. This isn\'t a formal event - wear what makes you feel good and ready to party.'
  },
  {
    question: 'What age range is this for?',
    answer: 'This party is for teens aged 15-19. ID check at the door to ensure everyone is in the right age group.'
  }
];